<template>
  <div id="app" class="min-h-screen flex flex-col bg-gray-200">
    <div class="flex-grow bg-cover bg-center bg-no-repeat" :style="{ backgroundImage: 'url(' + require(`@/assets/formulario.jpg`) + ')' }">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({

});
</script>
